module.exports = __webpack_public_path__ + "spa_static_mobile/img/more_operation.1d29e79a.png";